const SvgAtras: React.FC<{ className?: string; height?: number; width?: number }> = ({
  className,
  height,
  width,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`h-9 w-16 ${className ?? ""}`}
    width={width}
    height={height}
    fill="currentColor"
    viewBox="0 0 30 25"
  >
    {/* Flecha principal (fija, azul, se queda visible 2s) */}
    <path d="M18 5l-8 7 8 7" fill="#1D4ED8">
      <animate
        attributeName="opacity"
        values="0;1;1;1;0"
        keyTimes="0;0.2;0.5;0.8;1"
        dur="60s"
        repeatCount="indefinite"
      />
    </path>


    {/* Eco 1 */}
    <path d="M26 5l-8 7 8 7" opacity="0.15">
      <animateTransform
        attributeName="transform"
        type="translate"
        values="0 0; -16 0; -32 0"
        keyTimes="0;0.5;1"
        dur="2s"
        repeatCount="indefinite"
      />
      <animate
        attributeName="opacity"
        values="0.15;0.15;0"
        keyTimes="0;0.5;1"
        dur="2s"
        repeatCount="indefinite"
      />
    </path>

    {/* Eco 2 */}
    <path d="M34 5l-8 7 8 7" opacity="0.25">
      <animateTransform
        attributeName="transform"
        type="translate"
        values="0 0; -16 0; -32 0"
        keyTimes="0;0.5;1"
        dur="2s"
        begin="0.1s"
        repeatCount="indefinite"
      />
      <animate
        attributeName="opacity"
        values="0.25;0.25;0"
        keyTimes="0;0.5;1"
        dur="2s"
        begin="0.1s"
        repeatCount="indefinite"
      />
    </path>

    {/* Eco 3 */}
    <path d="M42 5l-8 7 8 7" opacity="0.35">
      <animateTransform
        attributeName="transform"
        type="translate"
        values="0 0; -16 0; -32 0"
        keyTimes="0;0.5;1"
        dur="2s"
        begin="0.2s"
        repeatCount="indefinite"
      />
      <animate
        attributeName="opacity"
        values="0.35;0.35;0"
        keyTimes="0;0.5;1"
        dur="2s"
        begin="0.2s"
        repeatCount="indefinite"
      />
    </path>

    {/* Eco 4 */}
    <path d="M50 5l-8 7 8 7" opacity="0.45">
      <animateTransform
        attributeName="transform"
        type="translate"
        values="0 0; -16 0; -32 0"
        keyTimes="0;0.5;1"
        dur="2s"
        begin="0.3s"
        repeatCount="indefinite"
      />
      <animate
        attributeName="opacity"
        values="0.45;0.45;0"
        keyTimes="0;0.5;1"
        dur="2s"
        begin="0.3s"
        repeatCount="indefinite"
      />
    </path>
  </svg>
);

export default SvgAtras;
